/* USP-balk als slider op mobiel (Gianni, 08-10): stipjes onder de balk en zelf doorschuiven,
   zodat zichtbaar is dat er meer garanties zijn. Begint altijd bij de eerste. Op desktop
   staan alle vakjes naast elkaar en doet dit script niets (de stipjes zijn daar verborgen). */
(function () {
  function bouw(usp) {
    var rail = usp.querySelector('.shell');
    if (!rail || usp.dataset.uspKlaar) return;
    var items = Array.prototype.slice.call(rail.children);
    if (items.length < 2) return;
    usp.dataset.uspKlaar = '1';
    var dots = document.createElement('div'); dots.className = 'usp-dots';
    items.forEach(function () { dots.appendChild(document.createElement('i')); });
    usp.appendChild(dots);
    var stip = Array.prototype.slice.call(dots.children), huidig = 0, timer = null, pauze = null;
    function mobiel() { return rail.scrollWidth > rail.clientWidth + 4; }
    function teken() { stip.forEach(function (s, i) { s.classList.toggle('is-active', i === huidig); }); }
    function naar(i, gedrag) { huidig = i; rail.scrollTo({ left: i * rail.clientWidth, behavior: gedrag || 'auto' }); teken(); }
    function start() { stop(); timer = setInterval(function () { if (mobiel()) naar((huidig + 1) % items.length, 'smooth'); }, 3500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function wacht() { stop(); clearTimeout(pauze); pauze = setTimeout(function () { if (inBeeld) start(); }, 7000); }
    rail.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { huidig = Math.round(rail.scrollLeft / (rail.clientWidth || 1)); teken(); });
    }, { passive: true });
    rail.addEventListener('touchstart', wacht, { passive: true });
    rail.addEventListener('pointerdown', wacht);
    /* Pas gaan lopen als de balk in beeld is, en buiten beeld terug naar de eerste:
       wie onderaan de pagina aankomt ziet dus altijd garantie 1 en dan 2, 3, 4. */
    var inBeeld = false;
    document.addEventListener('visibilitychange', function () { (document.hidden || !inBeeld) ? stop() : start(); });
    rail.scrollLeft = 0; teken();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        inBeeld = e[0].isIntersecting;
        if (inBeeld) { start(); } else { stop(); clearTimeout(pauze); naar(0); }
      }, { threshold: 0.6 }).observe(usp);
    } else { inBeeld = true; start(); }
  }
  function alles() { document.querySelectorAll('.usp').forEach(bouw); }
  document.addEventListener('DOMContentLoaded', alles);
  document.addEventListener('shopify:section:load', alles);
  alles();
})();
